import MatchDetailsOddModel from '../match-details/common/model-match-details-odd';
import MatchDetailsOutcomeModel from '../match-details/common/model-match-details-outcome';
import DateFilterService from '../../../services/date-filter-service';

/**
 * Match code model
 */
export default class MatchCodeModel {
  /**
   * Class constructor method
   * @param data
   */
  constructor(data) {
    /**
     * Guest team name
     * @type {string}
     */
    this.guestTeam = data.at;
    /**
     * Sport -> Category ID
     * @type {number}
     */
    this.categoryId = data.cid;
    /**
     * Match date (converted to local date)
     * @type {string}
     */
    this.date = DateFilterService.localDate(data.d, 'date', APP_SETTINGS.formatting.fullDateFormat, '');
    /**
     * Match time (converted to local time)
     * @type {string}
     */
    this.time = DateFilterService.localDate(data.d, 'time', '', APP_SETTINGS.formatting.fullTimeFormat);
    /**
     * eventCode
     * @type {number}
     */
    this.eventCode = data.ec;
    /**
     * Home team name
     * @type {string}
     */
    this.homeTeam = data.ht;
    /**
     * Sport -> Category -> Tournament -> Match ID
     * @type {number}
     */
    this.matchId = data.mid;
    /**
     * Match Odds + Odds->Outcomes
     * @type {array}
     */
    this.odds = this.mapOdds(data.o);
    /**
     * Sport ID
     * @type {number}
     */
    this.sportId = data.sid;
    /**
     * Sport -> Category -> Tournament ID
     * @type {number}
     */
    this.tournamentId = data.tid;
    /**
     * Match name
     * @type {string}
     */
    this.name = this.getName(data);
  }

  getName(data) {
    if (data.tus) {
      return `${this.guestTeam} @ ${this.homeTeam}`;
    }
    return `${this.homeTeam} vs ${this.guestTeam}`;
  }

  /**
   * Method for mapping inner objects from API with parent model
   * @param oddsList list of odds
   * @return mapped outcomes and odds in proper model
   */
  mapOdds(oddsList) {
    if (!oddsList) {
      return [];
    }
    let odds = [];
    oddsList.forEach((o) => {
      let odd = new MatchDetailsOddModel(o);
      odd.outcomes = o.m.map(m => new MatchDetailsOutcomeModel(m));
      odds.push(odd);
    });
    return odds;
  }
}
